import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//获取产品列表
export const productList = (params) => {
  return axios.get(`${base}/api/PreferredProducts/GetPreferredProductsList`, {
    params: params,
  });
};
//新增产品
export const addProduct = (params) => {
  return axios.post(
    `${base}/api/PreferredProducts/PostAddPreferredProducts`,
    params
  );
};
//修改产品
export const updateProduct = (params) => {
  return axios.post(
    `${base}/api/PreferredProducts/PostUpdatePreferredProducts`,
    params
  );
};
//删除产品
export const deleteProduct = (params) => {
  return axios.delete(`${base}/api/PreferredProducts/DeletePreferredProducts`, {
    params: params,
  });
};
//产品详情
export const productDetail = (params) => {
  return axios.get(`${base}/api/PreferredProducts/GetProductDetail`, {
    params: params,
  });
};

//订单列表
export const orderList = (params) => {
  return axios.post(`${base}/api/OrderManagerment/PostSelectOrderList`, params);
};
//订单详情
export const orderDetail = (params) => {
  return axios.get(`${base}/api/OrderManagerment/GetSelectOrderDetail`, {
    params: params,
  });
};
//删除订单
export const deleteOrder = (params) => {
  return axios.delete(`${base}/api/OrderManagerment/DeleteOrder`, {
    params: params,
  });
};
// 物流信息配置
export const PostUpdateLogisticsInfo = (params) => {
  return axios.post(
    `${base}/api/OrderManagerment/PostUpdateLogisticsInfo`,
    params
  );
};

export const GetSelectLogistics = (params) => {
  return axios.get(`${base}/api/OrderManagerment/GetSelectLogistics`, {
    params: params,
  });
};

// 配置订单发货员
export const PostUpdateOrderDeliverer = (data) => {
  return axios.put(`${base}/api/PublicParams/Put`, data);
};

// 获取订单发货员
export const GetSelectOrderDeliverer = () => {
  return axios.get(`${base}/api/PublicParams/GetSMSMessageInfo`);
};
